<template>
    <div
        v-if="active"
        class="modal d-block"
        @click="clickOutside($event)">
        <div class="modal-backdrop show"
             :style="{zIndex: 'unset'}"
        ></div>

        <div class="modal-dialog popup" :class="modalSizeClass">
            <div class="modal-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'standard'
        }
    },
    mounted() {
        this.$on('open', () => {
            document.body.classList.add('modal-open');
        });

        this.$on('close', () => {
            document.body.classList.remove('modal-open');
        });
    },
    methods: {
        clickOutside(event) {
            if (!event.target.closest('.popup')) {
                this.$emit('close');
            }
        },
    },
    computed: {
        modalSizeClass() {
            return this.size;
        }
    },
    watch: {
        active(value) {
            if (value) {
                this.$emit('open');
            } else {
                this.$emit('close');
            }
        }
    },
    beforeDestroy() {
        if (this.active) {
            this.$emit('close');
        }
    }
}
</script>

<style scoped lang="scss">
.standard {
    max-width: 550px !important;
}

.large {
    max-width: 900px !important;
}

.small {
    max-width: 300px !important;
}
.modal-dialog{
    max-height: 100vh;
}
</style>
